import t, { Component as e } from "react";
import o from "react-dom";
import { componentName as r } from "../../../utils/bem/index.js";
import { DotLoader as n } from "../../loaders/DotLoader/DotLoader.js";
import { Icon as i } from "../../general/Icon/Icon.js";
import { tip as c } from "../../forms/Tooltip/Tooltip.js";
import "../../../../node_modules/classnames/index.js";
import l from "../../../utils/ObjectUtils.js";
function a(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function s(t, e) {
  for (var o = 0; o < e.length; o++) {
    var r = e[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function p(t, e, o) {
  return e in t ? Object.defineProperty(t, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = o, t;
}
function u(t) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function f(t, e) {
  return (f = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
function m(e) {
  var o = e.icon,
    r = e.label,
    c = e.children,
    l = e.iconPlacement,
    a = e.isLoading,
    s = e.darkLoader,
    p = e.iconSvg;
  return a ? t.createElement(n, {
    dark: s
  }) : t.createElement(t.Fragment, null, o && "after" !== l && t.createElement(i, {
    regular: !0,
    name: o
  }), p && "after" !== l && t.createElement("img", {
    className: "button__icon-svg-before",
    src: p
  }), r || c || null, o && "after" === l && t.createElement(i, {
    regular: !0,
    name: o
  }), p && "after" === l && t.createElement("img", {
    className: "button__icon-svg-after",
    src: p
  }));
}
var b = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && f(t, e);
  }(y, e);
  var n,
    i,
    b,
    d = (n = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        o = u(y);
      if (n) {
        var r = u(this).constructor;
        e = Reflect.construct(o, arguments, r);
      } else e = o.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : a(this);
    });
  function y() {
    var t;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, y), t = d.apply(this, arguments), p(a(t), "tooltip", void 0), p(a(t), "element", void 0), p(a(t), "_handleClick", function (e) {
      if (!t.props.isLoading && !t.props.disabled) {
        var o, r;
        null === (o = (r = t.props).onClick) || void 0 === o || o.call(r, e);
      }
    }), p(a(t), "focus", function () {
      o.findDOMNode(t).focus();
    }), t;
  }
  return i = [{
    key: "componentDidMount",
    value: function value() {
      this.props.tooltip && (this.tooltip = c({
        className: r("button") + "__tooltip",
        target: this.element,
        content: this.props.tooltip,
        options: this.props.tooltipOptions
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.tooltip && (this.tooltip.destroy(), this.tooltip = null);
    }
  }, {
    key: "render",
    value: function value() {
      var e,
        o,
        n,
        i = this,
        c = this.props,
        a = c.isLoading,
        s = c.disabled,
        u = c.autoWidth,
        f = c.iconPlacement,
        b = c.variant,
        d = c.size,
        h = c.visible,
        O = r("button", this.props.className, (p(n = {
          disabled: s,
          isLoading: a
        }, b, "variant" in this.props && this.props.variant), p(n, d, "size" in this.props && this.props.size), p(n, "autoWidth", "autoWidth" in this.props && !1 !== u), p(n, "with-icon-before", "iconPlacement" in this.props && "before" === f), p(n, "with-icon-after", "iconPlacement" in this.props && "after" === f), n));
      if (!h) return null;
      var v = l.findDiffKeys(this.props, y.defaultProps);
      return t.createElement("button", (e = function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var o = null != arguments[e] ? arguments[e] : {},
            r = Object.keys(o);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function (t) {
            return Object.getOwnPropertyDescriptor(o, t).enumerable;
          }))), r.forEach(function (e) {
            p(t, e, o[e]);
          });
        }
        return t;
      }({}, v), o = o = {
        type: this.props.type,
        className: O,
        onClick: this._handleClick,
        ref: function ref(t) {
          return i.element = t;
        }
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : function (t, e) {
        var o = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          o.push.apply(o, r);
        }
        return o;
      }(Object(o)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
      }), e), t.createElement(m, this.props));
    }
  }], s(y.prototype, i), b && s(y, b), y;
}(e);
p(b, "displayName", "LoaderButton"), p(b, "defaultProps", {
  size: "regular",
  variant: "secondary",
  tooltip: null,
  tooltipOptions: null,
  visible: !0,
  autoWidth: !1,
  isLoading: !1,
  className: "",
  darkLoader: !1,
  default: !1,
  label: null,
  small: !1,
  icon: null,
  iconSvg: null,
  iconPlacement: "before",
  type: "button"
});
export { b as Button };